/* eslint-disable react/prop-types */
import { updateCookingTimeApi } from "@/api/take-order/take-order";
import { setCookingTime } from "@/redux/slice/take-order-slice/order-slice";
import { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";

function SetTime({ setSetTimePage, }) {
    const { orderData } = useSelector((state) => state.takeOrder.order);
    const dispatch = useDispatch();
    const [time, setTime] = useState(orderData?.cooking_time || 30);
    const quickTimes = [10, 15, 20, 30, 35, 40, 45, 50, 55, 60];


    function handleSave() {
        
        updateCookingTimeApi(orderData.id, { cooking_time: time }).then((res) => {
            if (res.status === "success") {
                toast.success("Cooking time updated successfully");
                dispatch(setCookingTime(time));
                setSetTimePage(false);
            }
        })
    }

    return (
        <div className="w-[600px] bg-color2 p-6 rounded-md border-2 border-color3 shadow-2xl text-white flex flex-col gap-6 items-center">
            <h2 className="text-xl font-semibold">
                Set Custom Time &gt; <span className="text-yellow-500">{(orderData?.order_type == "pickup")? "Pickup" : (orderData?.order_type == "delivery")? "Delivery" :  (orderData?.order_type == "in_house")? "In House" :  (orderData?.order_type == "table")? "Table" : "" }</span>
            </h2>

            <div className="flex items-center gap-4 w-full justify-center">
                <label className="text-xl font-medium">Time</label>
                <input 
                    type="text" 
                    value={time}
                    onChange={(e) => setTime(e.target.value)}
                    className="bg-color3 border border-gray-600 rounded p-2 w-48 text-center outline-none focus:border-gray-400"
                />
                <label className="text-xl font-medium">Minutes</label>
            </div>

            <div className="w-full">
                <div className=" bg-color3 text-center py-3 mb-4  font-medium rounded-sm">Quick Time</div>
                <div className="grid grid-cols-5 gap-3">
                    {quickTimes.map((t) => (
                        <button 
                            key={t}
                            onClick={() => setTime(t)}
                            className=" bg-color3 hover:bg-gray-500 text-white py-4 rounded-md font-semibold transition-colors"
                        >
                            {t}
                        </button>
                    ))}
                </div>
            </div>

            <div className=" w-full flex items-center justify-center gap-4">


                <button 
                    onClick={() => setSetTimePage(false)}
                    className=" w-full bg-color8  text-white px-12 py-2 rounded-md font-medium mt-4 transition-colors"
                >
                    Cancel
                </button>
                <button 
                    onClick={handleSave}
                    className=" w-full bg-color7 text-white px-12 py-2 rounded-md font-medium mt-4 transition-colors"
                >
                    Save
                </button>
            </div>
    </div>
);

}

export default SetTime;